// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"170":"215a53e7","221":"215a53e7","261":"215a53e7","507":"215a53e7","575":"215a53e7","946":"471a8b4b"}[chunkId] + ".chunk.css";
};